import React, { useState } from 'react';
import CallIcon from '@material-ui/icons/Call';
import {
  Open,
  followUp,
  interested,
  notInterested,
  followUpLead,
  OpenLead,
  interestedLead,
  notInterestedLead,
  more,
  hideMore,
  moreIcon,
  callIconBG,
  whatsApp,
  fontBarlow
} from './LeadDashboardMobile.module.css';
import { numberInTextFormat } from '../../../common/constants/numberInTextFormat';

import MoreVertIcon from '@material-ui/icons/MoreVert';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import moment from 'moment';
import CallOutlinedIcon from '@material-ui/icons/CallOutlined';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import WhatsAppIcon from '../../../images/icons/whatsApp_icon.svg';
import SvgComponent from '../../../common/components/SvgComponent/SvgComponent';
import MoreDetailLeadPage from './MoreDetailLeadPage';
import MakeACall from '../../../components/MakeACall/MakeACall';
import { setApplicantionInfo } from '../../../common/utils/applicantionInfo';
import { navigate } from 'gatsby';
import EditLead from '../EditLead';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
const whatsApp_icon = '/images/icons/whatsApp/WhatsApp.svg';

const AllLeadDashboardMobileEachElement = ({
  each,
  tableLoading,
  tableInfo,
  setPage,
  updateData,
  setShowWhatsApp,
  setUSerDataForWA,
  showSendDoc,
  setShowSendDoc
}) => {
  const [openFullDetail, setOpenFullDetail] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  let statusList = {
    Open: { style: Open, containerStyle: OpenLead },
    'Follow Up': { style: followUp, containerStyle: followUpLead },
    Interested: { style: interested, containerStyle: interestedLead },
    'Not Interested': {
      style: notInterested,
      containerStyle: notInterestedLead
    }
  };

  const getLoanTypeId = loanType => {
    switch (loanType) {
      case 'Personal Loan':
        return 13;
      case 'Business Loan':
        return 12;
      case '2 Wheeler Loan':
        return 14;
      case 'Home Loan':
        return 1;
      case 'LAP':
        return 2;
      default:
        return 1;
    }
  };

  const getStartApplicationBtn = row => {
    let applicationDetails = {
      leadId: row.leadId,
      leadApplicantId: row.leadMainApplicantId,
      applicationStatus: row.status,
      leadData: row
    };
    const handleClick = async () => {
      await setApplicantionInfo(applicationDetails);
    };
    const handleViewPD = async () => {
      await handleClick();
      navigate('/app/dashboard/lead/view/pd/all');
    };

    const handleReviewPD = async () => {
      await handleClick();
      let productId = await getLoanTypeId(row?.loanProduct);
      navigate(`/app/dashboard/lead/pd?loanType=${productId}`);
    };
    const handleStartPD = async () => {
      await handleClick();
      let productId = await getLoanTypeId(row?.loanProduct);
      navigate(`/app/dashboard/lead/pd?loanType=${productId}`);
    };

    if (row.status == 'Lead Rejected')
      return (
        <button
          className="bg-grey-delta capitalize py-1 px-3 w-full rounded text-white"
          onClick={handleViewPD}
        >
          View PD
        </button>
      );
    if (row.pdStatus == 'InProgress')
      return (
        <button
          className="bg-yellow-goldenGrass capitalize py-1 px-3 w-full rounded text-white"
          onClick={handleReviewPD}
        >
          Review PD
        </button>
      );
    else
      return (
        <button
          className="bg-green-tePapaGreen capitalize py-1 px-3 w-full rounded text-white"
          onClick={handleStartPD}
        >
          Start PD
        </button>
      );
  };
  const handleWhatsApp = () => {
    const data = {
      applicationStatus: each?.status || '',
      leadId: each?.leadId,
      leadApplicantId: each?.leadMainApplicantId,
      applicantInfo: {
        id: each?.leadMainApplicantId,
        mainApplicant: 'Main Applicant',
        phoneNumber: each?.phoneNumber
      },
      leadData: {
        loanAmount: each?.loanAmount || '---',
        loanProduct: each?.loanProduct || '---'
      }
    };

    setShowWhatsApp(true);
    setUSerDataForWA(data);
  };

  return (
    <div className="w-full px-3 py-2  bg-blue-1210">
      <div
        className={`w-full pl-1 rounded-md   ${statusList[
          each?.status || 'Open'
        ]?.containerStyle || OpenLead}`}
      >
        <div className="w-full  bg-white rounded-md px-2 pt-3">
          <div className="grid grid-cols-3">
            <div
              className="col-span-2 w-full"
              onClick={() => setOpenFullDetail(true)}
            >
              <p
                className={`font-semibold mb-3 text-lg text-green-600 capitalize font-barlow-semi-bold`}
              >
                {`${each?.leadName?.firstName || ''} ${each?.leadName
                  ?.middleName || ''} ${each?.leadName?.lastName || ''}`}
              </p>
              <p
                className={`font-normal text-sm text-black-850 mt-1 ${fontBarlow}`}
              >
                {each?.leadId}
                <span
                  className={`${statusList[each?.status || 'Open']?.style ||
                    Open} ${fontBarlow} font-normal   ml-1 text-sm py-1 px-2 rounded-sm ml-2`}
                >
                  {each?.status || '---'}
                </span>
                <span
                  className={`${fontBarlow} font-normal text-black-850 bg-grey-thinGray ml-1 text-sm py-1 px-2 rounded-sm`}
                >
                  {each?.subStatus || '---'}
                </span>
              </p>
              {showEditModal && (
                <EditLead
                  showModal={showEditModal}
                  setShowModal={setShowEditModal}
                  rowData={each}
                  onUpdation={updateData}
                />
              )}
            </div>
            <div className="w-table ml-auto col-span-1 flex ">
              <div className="table">
                <img
                  src={whatsApp_icon}
                  style={{ height: '35px' }}
                  onClick={handleWhatsApp}
                />
              </div>
              <div
                className={`px-1  w-8 h-8 ml-auto mr-3`}
                onClick={e => e.preventDefault()}
              >
                <MakeACall
                  phoneNumber={each?.leadApplicantPhone}
                  leadId={each?.leadId}
                  applicantId={each?.leadMainApplicantId}
                  PhoneNumberClasses="hidden"
                />
              </div>
            </div>
          </div>
          <div
            className="w-full grid grid-cols-3 mt-6"
            onClick={() => setOpenFullDetail(true)}
          >
            <div className="w-full">
              <p className="font-barlow font-normal text-xs text-black-1020 capitalize">
                Loan Type
              </p>
              <p
                className={` font-barlow-medium font-semibold  text-sm text-black-1025`}
              >
                {each?.loanProduct || '---'}
              </p>
            </div>
            <div className="w-full">
              <p className=" font-barlow font-normal text-xs text-black-1020 ">
                Loan Amount
              </p>
              <p
                className={`font-barlow-medium  font-semibold  text-sm text-black-1025`}
              >
                {each?.loanAmount && <span className="mr-0.5"> &#8377;</span>}
                {numberInTextFormat(each.loanAmount)}
              </p>
            </div>

            <div className="w-full">
              <p className="font-barlow font-normal text-xs text-black-1020 ">
                Credit Score
              </p>
              <p
                className={`font-barlow-medium  font-semibold  text-sm text-black-1025 `}
              >
                {each?.creditScore || '---'}
              </p>
            </div>
          </div>
          <hr className={`text-grey-greyLight mt-4`} />
          <div className=" py-3 grid grid-cols-3">
            <div
              className={`flex col-span-2`}
              onClick={() => setOpenFullDetail(true)}
            >
              <p className={`${fontBarlow} text-xs  text-black-1020 `}>
                RM Assigned
                <span className="float-right clear-both">:</span>
              </p>
              <p
                className={`font-barlow-medium font-semibold capitalize  text-black-850 ml-4`}
              >
                {`${each?.rmName?.firstName || ''} ${each?.rmName?.middleName ||
                  ''} ${each?.rmName?.lastName || ''}`}
              </p>
            </div>
            <div className="table ml-auto mr-2">
              {getStartApplicationBtn(each)}
            </div>
          </div>
        </div>
      </div>

      <MoreDetailLeadPage
        each={each}
        statusList={statusList}
        openFullDetail={openFullDetail}
        setOpenFullDetail={setOpenFullDetail}
        setShowEditModal={setShowEditModal}
        getLoanTypeId={getLoanTypeId}
        updateData={updateData}
        setShowWhatsApp={setShowWhatsApp}
        setUSerDataForWA={setUSerDataForWA}
        handleWhatsApp={handleWhatsApp}
        setShowSendDoc={setShowSendDoc}
      />
    </div>
  );
};
export default withErrorHandler(AllLeadDashboardMobileEachElement);
